import engine from 'store/src/store-engine';
import localStorage from 'store/storages/localStorage';
import cookieStorage from 'store/storages/cookieStorage';
import defaultsPlugin from 'store/plugins/defaults';
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {sections} from '../sectionConfig';
import {getFamilyConfig} from '../familyConfig';
import {setLocale} from '../components/configuratorApp';
import {selectSectionConfig} from '../selectors';

const storage = engine.createStore(
	[localStorage, cookieStorage],
	[defaultsPlugin]
);

export const duplicateConfiguration = createAsyncThunk(
	'status/duplicateConfiguration',
	async (options, {getState}) => {
		// TODO: implement duplicate
		//const dataManager = ProjectsDataManager.getInstance();
		//storage.set(config.lastUsedKeyName, dataManager.getDataKey());
		// recover previous project, if no project is available, start a new one
		// const projectKey = await dataManager.recoverProject();
		// dataManager.setCurrentProjectKey(projectKey);
	}
);
const statusInitialState = {
	formatVersion: 3,
	currentProjectKey: null,

	iframe: false,
	family: '',
	lang: '',
	region: '',
	mode: '',
	media: '',
	features: {
		relux: false,
		shortArticleNumber: false
	},

	productFamily: '',

	dashboardActive: false,
	settingsActive: false,
	specsheetActive: false,
	forceOverview: false,
	skipConfigurationEngine: true,

	modalActive: false,
	modalContent: null,
	modalTitle: null,

	explainActive: false,
	explanations: null,

	visualActive: false,
	debug: false,
	modeSwitchActive: false,
	usedSections: false,

	host: null,
	baseUrl: null,
	apiUrl: null,
	expressUrl: null,
	engineUrl: null,
	authUrl: null,
	pimUrl: null,
	priceUrl: null,
	shortNumberUrl: null,
	shortArticleNumberUrl: null,
	epimAssetsUrl: null,
	pvgisUrl: null,
	specsheetUrl: null,
	shortKey: null,
	dataManager: null,

	currentSection: '',
	currentSectionIndex: 0,
	cameFromSections: false,
	highlightFeatures: [],

	numbers: {
		majorNumbers: [1000, 3000, 5000, 9000, 11000],
		intermediateNumbers: [
			[1300, 1600, 1900, 2500],
			[4000],
			[],
			[9700, 10600]
		]
    },

};
export const statusSlice = createSlice({
	name: 'status',
	initialState: statusInitialState,
	reducers: {
		duplicate: (state, action) => {
			// TODO: implment duplicate
			console.log('duplicate');
			/*
			const dataManager = ProjectsDataManager.getInstance();
			dataManager.init('', false, false);
			const dataKey = dataManager.getDataKey();
			const rootKey = dataManager.getRootKey();
			const key = dataKey;
			console.log('duplicate key', key);
			storage.set(config.lastUsedKeyName, key);

			// recover previous project, if no project is available, start a new one
			const projectKey = dataManager.recoverProject();
			console.log('duplicate projectKey', projectKey);

			dataManager.setCurrentProjectKey(key);
			state.currentProjectKey = projectKey;

			const currentProject = dataManager.getCurrentProject();

			const lastPersistedBy = currentProject?.lastPersistedBy ?? 'External';
			const projectModelId = currentProject?.productModelId ?? 'Column';
			//const region = currentProject?.region ?? this.dataAttr().get('region') ?? 'int';
			//const lang = currentProject?.lang ?? this.dataAttr().get('lang') ?? 'de';

			updateUrl(state.baseUrl, state.media, key, true);

			//state.lang = lang;
			//state.region = region;
			state.dataKey = key;
			state.shortKey = key.substr(0, 8);
			state.productModel = projectModelId;
			console.log(state);
			*/
		},
		setStatus: (state, action) => {
			state = Object.assign(state, action.payload);
		},
		setModalActive: (state, action) => {
			state.modalActive = action.payload.modalActive;
			state.modalContent = action.payload.modalActive ? action.payload.content.replaceAll('␍', '\n') : null;
			state.modalTitle = action.payload.modalActive ? action.payload.title : null;
		},
		setExplainActive: (state, action) => {
			state.explainActive = action.payload.explainActive;
			state.explanations = action.payload.explanations;
		},
		setDebug: (state, action) => {
			state.debug = action.payload.debug;
		},
		setModeSwitchActive: (state, action) => {
			state.modeSwitchActive = action.payload.modeSwitchActive;
		},
		setSettingsActive: (state, action) => {
			state.settingsActive = action.payload.settingsActive;
		},
		toggleSettingsActive: (state, action) => {
			state.settingsActive = !state.settingsActive;
		},
		setLang: (state, action) => {
			state.lang = action.payload.lang;
			if (state.lang) {
				setLocale(state.lang);
			}
		},
		setRegion: (state, action) => {
			state.region = action.payload.region;
		},
		setFamily: (state, action) => {
			state.family = action.payload.family;
			state.forceOverview = getFamilyConfig(state.family).forceOverview;
			state.productFamily = getFamilyConfig(state.family).defaultProductFamily;
			state.skipConfigurationEngine = getFamilyConfig(state.family).skipConfigurationEngine;
		},
		setIframe: (state, action) => {
			state.iframe = action.payload.iframe;
		},
		setMedia: (state, action) => {
			// force overview, when configured
			if (state.forceOverview && action.payload.media === 'sections') {
				state.media = 'overview';
			} else {
				state.media = action.payload.media;
			}
			state.dashboardActive = state.media === 'overview';
			state.specsheetActive = state.media === 'specsheet';
			state.visualActive = state.media === 'sections';
			if (state.media === 'sections') {
				state.usedSections = true;
			}
		},
		setMode: (state, action) => {
			state.mode = action.payload.mode;
		},
		setKey: (state, action) => {
			state.dataKey = action.payload.key;
			state.shortKey = action.payload.key.substr(0, 8);
		},
		setRootKey: (state, action) => {
			state.rootKey = action.payload.rootKey;
		},
		setProjectKey: (state, action) => {
			state.currentProjectKey = action.payload.currentProjectKey;
		},
		setHighlightFeatures:  (state, action) => {
			state.highlightFeatures = action.payload.highlightFeatures;
		},
		removeHighlightFeatures:  (state, action) => {
			state.highlightFeatures = [];
		},
		firstSection: (state, action) => {
			const sectionConfig = action.payload.sectionConfig;
			state.currentSection = sectionConfig[0].id;
		},
		setSection: (state, action) => {
			state.currentSection = action.payload.currentSection;
		},
		setCameFromSections: (state, action) => {
			state.cameFromSections = action.payload;
		},
		nextSection: (state, action) => {
			//const currentIndex = sectionConfig.findIndex(section => section.id === state.currentSection);
			//const newIndex = currentIndex < sectionConfig.length - 1 ? currentIndex + 1 : sectionConfig.length - 1;
			//state.currentSection = sectionConfig[newIndex].id;
		},
		previousSection: (state, action) => {
			const sectionConfig = action.payload.sectionConfig;
			const currentIndex = sectionConfig.findIndex(section => section.id === state.currentSection);
			const newIndex = currentIndex > 0 ? currentIndex - 1 : 0;
			state.currentSection = sectionConfig[newIndex].id;
		},

		setMajorNumbers: (state, action) => {
			if (state.numbers?.majorNumbers) {
				state.numbers.majorNumbers = action.payload;
			}
		},

		setIntermediateNumbers: (state, action) => {
			if (state.numbers?.intermediateNumbers) {
				state.numbers.intermediateNumbers = action.payload;
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(duplicateConfiguration.fulfilled, (state, action) => {
			// TODO: implement duplication
			/*
			const dataManager = ProjectsDataManager.getInstance();
			const dataKey = dataManager.getDataKey();
			const currentProject = dataManager.getCurrentProject();

			state.currentProjectKey = currentProject?.key;
			state.lastPersistedBy = currentProject?.lastPersistedBy ?? 'External';
			state.dataKey = dataKey;
			state.shortKey = dataKey.substr(0, 8);
			state.currentSection = sections.default[0].id;
		 	*/
		});
		builder.addCase(duplicateConfiguration.pending, (state, action) => {
			console.log(action);
		});
		builder.addCase(duplicateConfiguration.rejected, (state, action) => {
			console.log(action);
		});
	}
});

export const {
	setSection,
	firstSection,
	nextSection,
	previousSection,
	setIframe,
	setStatus,
	setFamily,
	setLang,
	setRegion,
	setMedia,
	setMode,
	setKey,
	setRootKey,
	setSectionConfig,
	setProjectKey,
	setModalActive,
	setExplainActive,
	setDebug,
	setIntermediateNumbers,
	setMajorNumbers,
	setModeSwitchActive,
	setSettingsActive,
	toggleSettingsActive,
	duplicate,
	setHighlightFeatures,
	setCameFromSections,
	removeHighlightFeatures
} = statusSlice.actions;


export default statusSlice.reducer;
